<input
  [(ngModel)]="displayedLabel"
  #filterField
  matInput
  [class.has-button]="displayedLabel"
  (keyup)="doFilter(filterField.value)"
  (change)="doFilter(filterField.value)"
  (blur)="doBlur()"
  [matAutocomplete]="auto"
  [formlyAttributes]="field"
  [disabled]="props.disabled ?? false"
  [readonly]="props.readonly ?? false"
  [placeholder]="props.placeholder ?? ''"
  [errorStateMatcher]="errorStateMatcher"
/>

@if (displayedLabel) {
  <button
    nbButton
    ghost
    type="button"
    aria-label="Clear"
    (click)="clear()"
    class="clear-button float-end"
    [disabled]="props.readonly || props.disabled"
  >
    &times;
  </button>
}

<input hidden #actualControl [formControl]="formControl" />

<mat-autocomplete
  #auto="matAutocomplete"
  requireSelection
  [displayWith]="displayFn"
  (optionSelected)="optionSelected($event)"
>
  @for (item of filter | async; track item) {
    <mat-option [value]="item">
      {{ item.label }}
    </mat-option>
  }
</mat-autocomplete>

@if (props['modal']) {
  <button
    nbButton
    status="info"
    (click)="addModal()"
    size="small"
    type="button"
    class="me-1"
  >
    Add
  </button>
}
